import React from 'react';
import PropTypes from 'prop-types';
import config from '../../config';

const OfferHeader = ({ isLoggedIn }) => {
  const {
    funnelConfig: {
      signUpHeader,
      paymentHeader,
      paymentMessage,
    }
  } = config;
  const titleText = isLoggedIn
    ? paymentHeader
    : signUpHeader;
  const subtitleText = isLoggedIn
    ? paymentMessage
    : '';

  return (
    <div className="upgrade-header">
      <h1 className="upgrade-header__title">
        {titleText}
      </h1>
      <p className="upgrade-header__subtitle">
        {subtitleText}
      </p>
    </div>
  );
};

OfferHeader.propTypes = {
  isLoggedIn: PropTypes.bool
};

OfferHeader.defaultProps = {
  isLoggedIn: false,
};

export default OfferHeader;
